"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BulkApplyFailedRules = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _materialSymbols = require("@design/icons/material-symbols");
var _RedlinedText = require("@common/components/remedy/RedlinedText");
var _redlineEngine = require("@common/utils/redline/redline-engine");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var WORDING_EXCERPT = {
  contextUnits: 5,
  changeAuthors: [_redlineEngine.DIOPTRA_AUTHOR],
  changeStamps: [],
  countsMovesAsChanges: false,
  blockLimit: null
};
var List = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 8px;\n"])));
var Item = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border: 1px solid #e5e2dd;\n  border-radius: 6px;\n  overflow: hidden;\n"])));
var ItemHeader = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  padding: 8px 10px;\n  color: #1f2937;\n  font-size: 13px;\n"])));
var Toggle = _styledComponents.default.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  margin-top: 1px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: #6b7280;\n\n  svg {\n    width: 14px;\n    height: 14px;\n  }\n"])));
var TogglePlaceholder = _styledComponents.default.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n"])));
var NameLink = _styledComponents.default.button(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  padding: 0;\n  background: transparent;\n  border: none;\n  font: inherit;\n  font-weight: 600;\n  color: #1f2937;\n  text-align: left;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"])));
var Name = _styledComponents.default.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-weight: 600;\n"])));
var ItemReason = _styledComponents.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  color: #6b7280;\n  font-size: 12px;\n  line-height: 1.35;\n  margin-top: 2px;\n"])));
var ItemBody = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  border-top: 1px solid #eeebe6;\n  padding: 6px 10px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n"])));
var ParagraphBlock = _styledComponents.default.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n"])));
var WordingHeader = _styledComponents.default.div(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #6b7280;\n  margin-top: 4px;\n"])));
var WordingCards = _styledComponents.default.span(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-weight: 500;\n  letter-spacing: 0;\n  text-transform: none;\n  color: #6b7280;\n"])));
var CardLink = _styledComponents.default.button(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  padding: 0;\n  background: transparent;\n  border: none;\n  font: inherit;\n  color: #4b5563;\n  cursor: pointer;\n  text-decoration: underline;\n  text-decoration-color: #c9c5be;\n"])));
var WordingText = _styledComponents.default.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: #1f2937;\n  padding: 6px 8px;\n  background: #faf9f7;\n  border: 1px solid #eeebe6;\n  border-radius: 4px;\n  overflow-wrap: anywhere;\n"])));
function groupedByWording(cards) {
  var wordings = [];
  var _iterator = _createForOfIteratorHelper(cards),
    _step;
  try {
    var _loop = function _loop() {
      var card = _step.value;
      var existing = wordings.find(function (wording) {
        return wording.textProposed === card.textProposed;
      });
      if (existing) existing.cards.push(card);else wordings.push({
        textProposed: card.textProposed,
        cards: [card]
      });
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return wordings;
}
var CardNames = function CardNames(_ref) {
  var cards = _ref.cards,
    onShowRule = _ref.onShowRule;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(WordingCards, {
    "data-sentry-element": "WordingCards",
    "data-sentry-component": "CardNames",
    "data-sentry-source-file": "BulkApplyFailedRules.tsx",
    children: cards.map(function (card, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
        children: [index > 0 && ", ", onShowRule ? /*#__PURE__*/(0, _jsxRuntime.jsx)(CardLink, {
          type: "button",
          onClick: function onClick() {
            return onShowRule(card.ruleId);
          },
          children: card.ruleName
        }) : card.ruleName]
      }, card.ruleId);
    })
  });
};
var WordingBlock = function WordingBlock(_ref2) {
  var label = _ref2.label,
    wording = _ref2.wording,
    textBefore = _ref2.textBefore,
    onShowRule = _ref2.onShowRule;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(WordingHeader, {
      "data-sentry-element": "WordingHeader",
      "data-sentry-source-file": "BulkApplyFailedRules.tsx",
      children: [label, /*#__PURE__*/(0, _jsxRuntime.jsx)(CardNames, {
        cards: wording.cards,
        onShowRule: onShowRule,
        "data-sentry-element": "CardNames",
        "data-sentry-source-file": "BulkApplyFailedRules.tsx"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(WordingText, {
      "data-sentry-element": "WordingText",
      "data-sentry-source-file": "BulkApplyFailedRules.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RedlinedText.RedlinedText, {
        textBefore: textBefore,
        text: wording.textProposed,
        author: _redlineEngine.DIOPTRA_AUTHOR,
        changeExcerpt: WORDING_EXCERPT,
        "data-sentry-element": "RedlinedText",
        "data-sentry-source-file": "BulkApplyFailedRules.tsx"
      })
    })]
  });
};
var ParagraphWordings = function ParagraphWordings(_ref3) {
  var paragraph = _ref3.paragraph,
    onShowRule = _ref3.onShowRule;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(ParagraphBlock, {
    "data-sentry-element": "ParagraphBlock",
    "data-sentry-component": "ParagraphWordings",
    "data-sentry-source-file": "BulkApplyFailedRules.tsx",
    children: [groupedByWording(paragraph.chosen).map(function (wording) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(WordingBlock, {
        label: "Chosen",
        wording: wording,
        textBefore: paragraph.textBefore,
        onShowRule: onShowRule
      }, wording.textProposed);
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(WordingBlock, {
      label: "Not applied",
      wording: {
        textProposed: paragraph.refused.textProposed,
        cards: [paragraph.refused]
      },
      textBefore: paragraph.textBefore,
      onShowRule: onShowRule,
      "data-sentry-element": "WordingBlock",
      "data-sentry-source-file": "BulkApplyFailedRules.tsx"
    })]
  });
};
var FailedRuleRow = function FailedRuleRow(_ref4) {
  var _rule$ruleName, _rule$reason;
  var rule = _ref4.rule,
    detail = _ref4.detail,
    defaultOpen = _ref4.defaultOpen,
    onShowRule = _ref4.onShowRule;
  var _useState = (0, _react.useState)(defaultOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var name = (_rule$ruleName = rule.ruleName) !== null && _rule$ruleName !== void 0 ? _rule$ruleName : rule.ruleId;
  var reason = (_rule$reason = rule.reason) !== null && _rule$reason !== void 0 ? _rule$reason : detail === null || detail === void 0 ? void 0 : detail.reason;
  var hasWordings = detail !== undefined && detail.paragraphs.length > 0;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Item, {
    "data-sentry-element": "Item",
    "data-sentry-component": "FailedRuleRow",
    "data-sentry-source-file": "BulkApplyFailedRules.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(ItemHeader, {
      "data-sentry-element": "ItemHeader",
      "data-sentry-source-file": "BulkApplyFailedRules.tsx",
      children: [hasWordings ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Toggle, {
        type: "button",
        onClick: function onClick() {
          return setIsOpen(function (open) {
            return !open;
          });
        },
        "aria-expanded": isOpen,
        "aria-label": isOpen ? "Hide wordings" : "Show wordings",
        children: isOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.KeyboardArrowDownIcon, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronRightIcon, {})
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(TogglePlaceholder, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          minWidth: 0,
          flex: 1
        },
        children: [onShowRule ? /*#__PURE__*/(0, _jsxRuntime.jsx)(NameLink, {
          type: "button",
          onClick: function onClick() {
            return onShowRule(rule.ruleId);
          },
          children: name
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(Name, {
          children: name
        }), reason && /*#__PURE__*/(0, _jsxRuntime.jsx)(ItemReason, {
          children: reason
        })]
      })]
    }), hasWordings && isOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)(ItemBody, {
      children: detail.paragraphs.map(function (paragraph) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(ParagraphWordings, {
          paragraph: paragraph,
          onShowRule: onShowRule
        }, paragraph.bookmark);
      })
    })]
  });
};
var BulkApplyFailedRules = exports.BulkApplyFailedRules = function BulkApplyFailedRules(_ref5) {
  var failedRules = _ref5.failedRules,
    details = _ref5.details,
    onShowRule = _ref5.onShowRule;
  var detailOf = new Map(details.map(function (detail) {
    return [detail.ruleId, detail];
  }));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(List, {
    "data-sentry-element": "List",
    "data-sentry-component": "BulkApplyFailedRules",
    "data-sentry-source-file": "BulkApplyFailedRules.tsx",
    children: failedRules.map(function (rule, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(FailedRuleRow, {
        rule: rule,
        detail: detailOf.get(rule.ruleId),
        defaultOpen: index === 0,
        onShowRule: onShowRule
      }, rule.ruleId);
    })
  });
};